import Api from 'src/api/Base'

class GetSharePointNominationTemplate extends Api {
  requestUrl = `/api/SharePointNomination/template`
}
export default GetSharePointNominationTemplate
